import React from 'react';
import styled from '@emotion/styled';
import sizes from 'style/sizes';
import { mq } from 'style/variables';
import { Video } from 'components/atoms/video';

type FullVideoProps = {
  url: string;
};

const Container = styled.div`
  width: 100%;
  ${mq.onlypc} {
    max-width: 1920px;
    margin: 0 auto ${sizes.margin[209]};
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
  }
`;

export const FullVideo: React.FC<FullVideoProps> = props => {
  return (
    <Container {...props}>
      <Video url={props.url} />
    </Container>
  );
};
